import { useCallback } from "react";

import { liveChat } from "@jti/fe-clients";
import { BrowserStorage, CasProfileApi, User } from "@jti/rest-api";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

export function useLogOut(onLogoutCb: () => void, setIsPending?: (isPending: boolean) => void) {
  const onLogout = useCallback(async () => {
    const user = new User(new BrowserStorage());
    const { uuid } = user.getUser();
    dispatchTrackingEvent(TrackingEvents.TrackingLogoutSuccess, { user_id: uuid || "no id" });

    try {
      setIsPending?.(true);
      await CasProfileApi.init().logout();
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      user.clearUser();
      liveChat.onLogout();

      // LiveChat does not provide a way for us to know what happened with the request,
      // so we wait for 500ms and hope for the best 🤞
      setTimeout(() => {
        setIsPending?.(false);
        onLogoutCb();
      }, 500);
    }
  }, [onLogoutCb]);

  return onLogout;
}
